import React from "react";

type Props = Readonly<{
  htmlContent: string | undefined;
  className?: string;
  containerRef?: React.Ref<HTMLDivElement>;
}>;

export const RawUhfContainer = ({ htmlContent, className, containerRef }: Props) => {
  if (!htmlContent) {
    return null;
  }

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
      ref={containerRef}
    />
  );
};
